export default __webpack_public_path__ + "static/media/illustration-mian-w.07c79b5d.webp";